import React from 'react';
import { CalendarCheckIcon, MessageSquareIcon, PhoneCallIcon } from 'lucide-react';
import { Reveal } from './showcase/Reveal';
const tiles: {
  label: string;
  icon: typeof PhoneCallIcon;
}[] = [{
  label: 'Missed calls answered live',
  icon: PhoneCallIcon
}, {
  label: 'Written leads answered in under 60 seconds',
  icon: MessageSquareIcon
}, {
  label: 'Booked, logged, and signed before the showing',
  icon: CalendarCheckIcon
}];
export function ValueStrip() {
  return <section aria-label="What the system does" className="border-b border-white/5 bg-ink-900" data-id="element-414" data-mp="32o5580qop1z9">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 sm:py-20" data-id="element-415" data-mp="37nhsgmlgwb2d">
        <ul className="grid gap-4 md:grid-cols-3" data-id="element-416" data-mp="37ldpc6ve7g35">
          {tiles.map((tile, index) => {
          const Icon = tile.icon;
          return <li key={tile.label} className="h-full" data-id="element-417" data-mp="1da8o197s3fqz" data-mpi={index}>
                <Reveal delay={0.06 * index} className="h-full" data-id="element-418" data-mp="1i8a89xgxxl41">
                  <div className="flex h-full items-start gap-4 rounded-xl border border-white/10 bg-ink-800 p-6" data-id="element-419" data-mp="1i8tn35bantdu">
                    <Icon className="mt-0.5 h-5 w-5 flex-none text-brand" aria-hidden="true" data-id="element-420" data-mp="pg4cfnb34osn" />
                    <p className="font-display text-base font-semibold leading-snug text-white" data-id="element-421" data-mp="kl85zi53pyw0">
                      {tile.label}
                    </p>
                  </div>
                </Reveal>
              </li>;
        })}
        </ul>

        <Reveal delay={0.12} className="mt-10" data-id="element-422" data-mp="18buetbmxjn72">
          <p className="rounded-xl border border-brand/30 bg-brand/[0.07] px-6 py-5 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-423" data-mp="18ajc7f580lhj">
            This is built for teams doing 50 or more sides a year that buy leads. If that
            is not you yet, we will cheer for you from here.
          </p>
        </Reveal>
      </div>
    </section>;
}